<template>
  <v-card
    class="ma-0 px-1"
    width="100%"
    flat
  >
    <v-app-bar
      flat
      class="my-0 mb-2 py-1 px-4"
      dense
      height="30"
    >
      <v-toolbar-title> {{ $t('entrepot') }}</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="id"
            v-bind="attrs"
            icon
            small
            class="float-left"
            v-on="on"
            @click="goTo('entrepot')"
          >
            <v-icon
              color="teal"
              style="font-size: 22px"
            >
              mdi-plus-box-outline
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('entrepot') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="goTo( 'entrepotList')"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-format-list-numbered
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('entrepotList') }}</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            v-if="!formType"
            v-bind="attrs"
            icon
            small
            v-on="on"
            @click="$router.go(-1)"
          >
            <v-icon
              color="primary"
              style="font-size: 22px"
            >
              mdi-arrow-left
            </v-icon>
          </v-btn>
        </template>
        <span>{{ $t('back') }}</span>
      </v-tooltip>
    </v-app-bar>
    <v-progress-linear
      :active="!render"
      :indeterminate="!render"
      absolute
      bottom
      style="top: -4px"
      color="primary"
    />
    <v-form
      v-if="render"
      ref="form"
      v-model="valid"
      lazy-validation
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <v-text-field
              v-model="name"
              :label="$t('name')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="9"
          >
            <v-text-field
              v-model="address"
              :label="$t('address')"
              height="20"
              dense
              :rules="[v => !!v || $t('is-required')]"
              outlined
              class="mb-1 dense"
              clearable
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            sm="3"
            class="mb-0  "
          >
            <autocomplete
              v-model="given"
              :title="$t('given')"
              type="given"
            />
          </v-col>
        </v-row>
      </v-container>
      <v-card-actions>
        <v-row class="ma-0">
          <v-col
            cols="6"
            class="px-1"
          >
            <v-btn
              v-if="!id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="create"
            >
              {{ $t('submit') }}
            </v-btn>
            <v-btn
              v-if="id"
              color="primary"
              class="mr-0"
              :loading="isLoading"
              @click="update"
            >
              {{ $t('submit') }}
            </v-btn>
          </v-col>
          <v-col
            cols="6"
            class="px-2"
          >
            <v-btn
              color="grey"
              outlined
              class="float-left"
              @click="goTo( 'entrepotList' )"
            >
              {{ $t('entrepotList') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-form>
    <v-snackbar
      v-model="snakbar"
      :color="(snakbarColor ? snakbarColor : 'primary')"
      top
      style="z-index: 1000000000000 !important;"
    >
      {{ snakbarText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="white"
          text
          v-bind="attrs"
          @click="snakbar = !snakbar"
        >
          {{ $t('close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
// import aicomplete from '../../components/general/AIcomplete/index'
import General from '../../../../Mixins/general'
export default {
  name: 'Product',
  components: {
  },
  mixins: [General],
  props: ['formType'],
  data: () => ({
    options: {
      locale: 'en-US',
      prefix: '',
      suffix: ' ',
      precision: 0
    },
    render: false,
    isLoading: false,
    alert: false,
    address: null,
    given: null,
    from: null,
    tag: null,
    content: null,
    valid: null,
    message: null,
    alertType: null,
    name: null,
    type: null,
    id: null,
    status: 'active',
    group: null,
    loading: false
  }),
  watch: {
    snakbar () {
    }
  },
  beforeMount () {
    if (this.$route.params.id != null) {
      this.show()
      this.id = this.$route.params.id
      this.render = false
    } else {
      this.render = true
    }
  },
  mounted () {
  },
  methods: {
    create () {
      var app = this
      app.isLoading = true
      app.$axios.post(this.$endpoint + 'warehouse', app.$data)
        .then(res => {
          app.goTo('entrepotList')
          app.clearForm()
        })
        .catch(err => {
          this.serverErrorHandeler(err)
        })
        .finally(() => {
          app.isLoading = false
        })
    },
    show () {
      var app = this
      app.loading = true
      app.clearing = true
      app.showing = true
      app.$axios.get(this.$endpoint + 'warehouse/' + this.$route.params.id + '/edit', {
        params: {
          id: this.$route.params.id
        }
      })
        .then(res => {
          res = res.data
          app.$nextTick(() => {
            app.id = res.id
            app.name = res.name
            app.given = res.given
            app.address = res.address
            app.render = true
          })
        })
        .catch(err => {
          app.serverErrorHandeler(err)
        })
        .finally(() => (app.loading = false))
    },
    update () {
      var app = this
      app.isLoading = true
      app.$axios.put(this.$endpoint + 'warehouse/' + this.$route.params.id, this.$data)
        .then(res => {
          res = res.data
          app.$emit('close', app.$route)
          app.clearForm()
          app.goTo('entrepotList')
        })
        .catch(err => {
          app.serverErrorHandeler(err)
        })
        .finally(() => {
          app.isLoading = false
        })
    },
    clearForm () {
      this.address = null
      this.name = null
    }
  }
}
</script>

<style scoped>

</style>
